export const SET_CATALOGS = 'SET_CATALOGS';

export const setCatalogs = (data) => ({
  type: SET_CATALOGS,
  payload: data,
});